import request from "@/utils/request";

export function getPlatFormCate() {
  return request({
    url: "/product/platform-cate/all",
    method: "get",
  });
}
export function getBrandPlaceList(params) {
  return request({
    url: "/product/participate/brand-goods/page",
    method: "get",
    params,
  });
}
export function getHomeBanner() {
  return request({
    url: "/setting/advertising/top-banner",
    method: "get",
  });
}
// 获取背景图
export function getHomeBackground() {
  return request({
    url: "/setting/advertising/background-banner",
    method: "get",
  });
}
// 获取中缝banner
export function getMiddleBanner() {
  return request({
    url: "/setting/advertising/middle-banner",
    method: "get",
  });
}
// 获取中缝下banner
export function getBottomBanner() {
  return request({
    url: "/setting/advertising/bottom-one-banner",
    method: "get",
  });
}
// 获取下方banner
export function getEndBanner() {
  return request({
    url: "/setting/advertising/bottom-banner",
    method: "get",
  });
}
// 获取频道设置
export function getChannel() {
  return request({
    url: "/setting/channel-menu/list",
    method: "get",
  });
}
// 获取频道样式设置
export function getChannelStyle() {
  return request({
    url: '/setting/channel-set/find',
    method: 'get'
  })
} 

export function getRedpackCenter() {
  return request({
    url: "/product/red-packet/redPacket/center",
    method: "get",
  });
}

export function getRedpack(id) {
  return request({
    url: "/product/red-packet/claim/" + id,
    method: "put",
  });
}
export function getStoreRedpack() {
  return request({
    url: "/product/store-red-packet/claim-ordinary",
    method: "put",
  });
}

export function getMessage() {
  return request({
    url: "/user/internal-message/findByCustomerId",
    method: "get",
  });
}
